import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $f7router = _ref.$f7router,
      $on = _ref.$on,
      $update = _ref.$update;

  /**
   * Modifica lingua
   * 
   * @param {type} ev
   * @returns {undefined}
   */
  var changeLanguage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ev) {
      var selectedLanguage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedLanguage = $(ev.target).data('lang');
              lng = language[selectedLanguage];
              localStorage.language = selectedLanguage;
              $update();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function changeLanguage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var goToHome = function goToHome() {
    myApp.languageChanged = true;
    $f7router.navigate('/services/', {
      ignoreCache: true
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="set_language">
    <!-- Top Navbar -->
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="title sliding">Doctor Pass</div>
        <div class="right">
          <a href="#" class="link icon-only panel-open" data-panel="right">
            <i class="icon f7-icons if-not-md">menu</i>
            <i class="icon material-icons if-md">menu</i>
          </a>
        </div>
      </div>
    </div>
    <!-- Scrollable page content-->
    <div class="page-content bg-color-white hide-navbar-on-scroll display-flex flex-direction-column justify-content-center align-items-center">
      <h3>${lng.set_language}</h3>
      <div class="block row">
        <div class="col text-align-center">
          <img src="static/flags/en.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="en" alt=""/>
          English
          ${lng.key === 'en' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/it.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="it" alt=""/>
          Italiano
          ${lng.key === 'it' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/fr.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="fr" alt=""/>
          Français
          ${lng.key === 'fr' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/de.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="de" alt=""/>
          Deutsch
          ${lng.key === 'de' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
        <div class="col text-align-center">
          <img src="static/flags/es.png" width="100%" style="max-width: 55px" @click=${changeLanguage} data-lang="es" alt=""/>
          Español
          ${lng.key === 'es' ? $h`
          <div class="highlight-bar"></div>
          `:''}
        </div>
      </div>
      <h3>${lng.language}</h3>
      <a href="#" class="button button-large button-round button-outline color-secondary" @click=${goToHome}>
        <i class="f7-icons">checkmark_alt</i>
        ${lng.set_language}
      </a>
    </div>
  </div>
`
    }
    ;
});